export default "__VITE_ASSET__007b294d__"